<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>活动列表</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-select
          style="margin-right: 10px"
          width="300px"
          v-model="searchSort"
          placeholder="应用类型筛选"
          clearable
          value-key="index"
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <!-- <el-option
              v-for="item in [
                {
                  index: 1,
                  name: '管理端',
                  useType: 'a'
                },
                {
                  index: 2,
                  name: '服务商端',
                  useType: 'b'
                },
                {
                  index: 3,
                  name: '推广端',
                  useType: 't'
                },
                {
                  index: 4,
                  name: 'C端',
                  useType: 'z'
                }
              ]"
              :key="item.index"
              :label="item.name"
              :value="item"
            ></el-option> -->
        </el-select>
        <el-input
          placeholder="请输入活动模板名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button type="primary" @click="doNew" class="c-m-l-10">新建活动模板</el-button> -->
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:otherPhone|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                'fpi-regex:_id|string#or': searchValue,
                beanName: 'activityDef',
                title: '活动'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item
                      v-if="scope.row.exts.activityDefType == '4'"
                      @click.native="openDoDefQrcode(scope.row)"
                    >
                      生成小微服务站渠道码
                    </el-dropdown-item> -->
                  <!-- <el-dropdown-item @click.native="viewPoster(scope.row)">
                      查看门店二维码
                    </el-dropdown-item> -->
                  <el-dropdown-item @click.native="viewPoster(scope.row)">
                    查看二维码
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state === 0"
                    @click.native="doEnable(scope.row)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state === 1"
                    @click.native="doDisable(scope.row)"
                  >
                    禁用
                  </el-dropdown-item>
                  <!-- <el-dropdown-item @click.native="doRemove(scope.row)">
                      删除
                    </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="修改活动内容" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="活动二维码"
      :visible.sync="openQRDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <!-- :style="{ backgroundImage: 'url(' + tplImageFileid + ')' }" -->
      <!-- <div id="posterHtml" v-show="isShowBg"> -->
      <!-- <img :src="tplImageFileid" :style="'height:' + bjHeightT + 'px'" id="bg" alt="背景图" /> -->
      <div style="display: flex; align-items: center">
        分享二维码：
        <div id="qrCodeUrl" style="margin: 20px 0 0 10px" ref="qrCodeUrl"></div>
      </div>
      <div style="margin-top: 26px">
        <span>分享长链接：</span>
        <el-link :href="href" target="_blank">{{ `${href}` }}</el-link>
      </div>
      <!-- </div> -->
      <!-- <div>
          生成的海报
          <el-image :src="this.posterImg" :fit="cover"></el-image>
        </div> -->

      <div slot="footer" style="display: flex; justify-content: space-between">
        <span></span>
        <el-button type="primary" @click="openQRDetail = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量生成活动二维码弹框 -->
    <el-dialog
      title="批量生成活动渠道二维码"
      :visible.sync="showDoDefQrcode"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
      <div style="display: flex; align-items: center;justify-content: space-between;">
        生成数量：
        <el-input-number v-model="DefQrcodeNum" :min="1" label="描述文字"></el-input-number>
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="doInit">取 消</el-button>
        <el-button type="primary" @click="doDefQrcode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  activated() {
    window.$this = this;
  },
  name: 'activity',
  data() {
    window.$this = this;
    return {
      name: 'activity',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        useType: 'a'
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      },
      href: '', //二维码地址
      openQRDetail: false,
      tplQrcodeSize: '', //实际二维码大小
      tplQrcodeSizeT: '', //图上二维码大小
      tplImageFileid: '',
      isShowBg: false,
      posterImg: '', //生成的海报
      bgSize: {}, //背景实际大小
      bjHeightT: '', //背景图上的高
      qrTitle: '', //二维码弹窗标题
      searchSort: null,
      showDoDefQrcode: false, //批量生成小微服务站活动码弹框
      defId: '', //模板id
      DefQrcodeNum: '' //二维码数量
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('activity', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    handleClose() {
      this.doInit();
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.showDoDefQrcode = false;
      this.defId = '';
      this.DefQrcodeNum = '';
      this.formData = { exts: {}, tplImageFileid: [], useType: 'a' };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'ne:state|integer#and': -1 && -99,
        'is:useType|string#and': this.searchSort && this.searchSort.useType
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/activity/query.do', params, res => {
        res.data.map(item => {
          item.tplImageFileid = JSON.parse(item.tplImageFileid);
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.$refs.formData) {
          this.$refs.form.$refs.formData.clearValidate();
        }
      });
    },
    doSave() {
      if (this.osg.validate()) {
        console.log('11formdata', this.formData);
        this.$util.saveFormatExtField(this.extFields, this.formData);
        // 海报模板
        this.formData.tplImageFileid = JSON.stringify(this.formData.tplImageFileid);
        console.log(this.formData, '--this.formData');
        this.osg.ajax('biz/activity/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      // this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doEnable(row) {
      this.osg.confirm(`是否确认启用模板“${row.name}”？`, () => {
        this.osg.ajax('biz/activity/enable.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doDisable(row) {
      this.osg.confirm(`是否确认禁用模板“${row.name}”？`, () => {
        this.osg.ajax('biz/activity/disable.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除“${row.name}”？`, () => {
        this.osg.ajax('biz/activityDef/delete.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },

    beforeRemove(file, fileList, field) {
      let status = true;
      if (file && file.status === 'success') {
        status = this.$confirm('确定删除？');
      }
      return status;
    },
    // 生成二维码方法
    bindQRCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.href}`,
        // width: this.tplQrcodeSize,
        // height: this.tplQrcodeSize,
        width: 200,
        height: 200,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
      // this.$nextTick(() => {
      //   this.createPoster();
      // });
    },

    viewPoster(row, type) {
      // if (type == 'bd') {
      //   this.href = row.tplQrcode.replace('tg', 'bd');
      //   console.log(this.href, '---href');
      //   this.qrTitle = '活动获客码';
      // } else {
      //   this.href = row.tplQrcode;
      //   this.qrTitle = '活动门店码';
      // }
      // type = type || (this.type ? this.type : 'bd');
      // console.log(row, 'viewPoster');
      this.href = row.tplQrcode;
      this.tplQrcodeSize = row.tplQrcodeSize;
      this.tplImageFileid = row.tplImageFileid[0].url;
      // this.datadragEnd();

      // console.log(this.href, 'href');
      this.openQRDetail = true;
      this.$nextTick(() => {
        this.bindQRCode();
        // this.createPoster();
      });
    },
    openDoDefQrcode(item) {
      if (item.state == 0) {
        this.osg.toast('模板未启用', 'warning');
        return;
      }
      this.defId = item._id;
      this.showDoDefQrcode = true;
    },
    // 批量生成小微服务站活动二维码
    doDefQrcode() {
      debugger;
      this.osg.ajax(
        '/biz/activityDef/qrcode.do',
        { id: this.defId, count: this.DefQrcodeNum },
        res => {
          debugger;
          console.log(res.headers, '---temp');
          let temp = res.headers['content-disposition'].split('=')[1];
          let iconv = require('iconv-lite');
          iconv.skipDecodeWarning = true; //忽略警告
          let fileName = iconv.decode(temp, 'gbk');
          fileName = fileName.substring(1, fileName.length - 1);
          let blob = new Blob([res.data]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          console.log(res, '---defqr');
          this.doInit();
          this.osg.toast('操作成功！');
        },
        {
          responseType: 'blob'
        }
      );
    },
    datadragEnd() {
      // 创建实例对象
      var img = new Image();
      img.src = this.tplImageFileid;
      let that = this;
      img.onload = function() {
        that.bgSize = {
          width: img.width,
          height: img.height
        };
        // that.QRwidth = that.bgSize.width/3
        // console.log(that.QRwidth,'-------that.QRwidth')
        let proportion = '';
        proportion = that.bgSize.width / 400;
        that.bjHeightT = that.bgSize.height / proportion;
        that.tplQrcodeSizeT = that.tplQrcodeSize / proportion;
        console.log(that.bjHeightT, '---this.bjHeightT');
        console.log(proportion, '---比例');
        console.log(that.tplQrcodeSizeT, '--图上二维码');
        // console.log(
        //   that.bgSize,
        //   '---------获取到图片的宽高',
        //   that.bgSize.height,
        //   '--高',
        //   that.bgSize.width,
        //   '--宽'
        // );
        //获取到图片的宽高
      };
    }
  }
};
</script>
<style>
/*整个海报*/
#posterHtml {
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  background-size: 100% 450px;
  margin: 0;
  padding: 0;
}
/*二维码*/
#qrCodeUrl {
  /* position: absolute; */
  /* top: 20px; */
  /* width: 25%; */
  /* height: 150px; */
  /* float: right; */
  /* margin-top: 108%; */
}
#bg {
  width: 400px;
}
</style>
